<div class="popup-overlay">
  <div class="modal-content popup">
    <span class="close-button" (click)="submitDateTime(false)">×</span>

    <div class="content">
      <div class="row">
        <div class="col-md-3">
          <label for="status">Status:</label>
        </div>
        <div class="col-md-8">
          <select id="status" [(ngModel)]="selectedStatus" class="form-control">
            <option *ngFor="let status of statusOptions" [value]="status">
              {{ status }}
            </option>
          </select>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3">
          <label for="status">Reason:</label>
        </div>
        <div class="col-md-8">
          <select id="reason" [(ngModel)]="selectedReason" class="form-control">
            <option *ngFor="let reason of reasonOptions" [value]="reason">
              {{ reason }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="btn row">
      <button class="hover-clear" (click)="submitDateTime(true)">Submit</button>
      <button class="hover-clear" (click)="submitDateTime(false)">
        Cancel
      </button>
    </div>
  </div>
</div>
